import type { HTMLAttributes } from "react";

import { cn } from "../../utils";

export type DialogHeaderProps = HTMLAttributes<HTMLDivElement>;

const Header = ({ className, ...props }: DialogHeaderProps) => (
  <div className={cn("flex px-6 text-2xl font-bold text-neutral-10", className)} {...props} />
);

Header.displayName = "Header";

export default Header;
